import { Edit } from '@wix/wix-ui-icons-common/on-stage';
import type { FC } from 'react';
import React from 'react';

import { classes } from './EditIcon.st.css';

export const EditIcon: FC = () => <Edit className={classes.root} />;
